import React, { useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import "../styles/DashboardPage.css";
import AdmissionPage from "./AdmissionPage";
import HiringPage from "./HiringPage";
import { FaBars } from "react-icons/fa"; // Importing a better icon

const HeaderL = ({ toggleSidebar }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("userId"); // Remove user session
    navigate("/login"); // Redirect to login page
  };

  return (
    <header className="headerL">
      <button onClick={toggleSidebar} className="toggle-btnL">
        <FaBars />
      </button>
      Shri Kheteshwar Gurukul (Portal Login)
      <button onClick={handleLogout} className="logout-buttonL">Logout</button>
    </header>
  );
};

const SidebarL = ({ isCollapsed }) => {
  const navigate = useNavigate();
  return (
    <nav className={`sidebarL ${isCollapsed ? "collapsed" : ""}`}>
      <ul>
        <li>
          <button onClick={() => navigate("/dashboard/admission")} className="nav-buttonL">
            Student Form
          </button>
        </li>
        <li>
          <button onClick={() => navigate("/dashboard/hiring")} className="nav-buttonL">
            Staff Form
          </button>
        </li>
      </ul>
    </nav>
  );
};

const DashboardPage = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className="dashboard-containerL">
      <SidebarL isCollapsed={isCollapsed} />
      <div className={`content-areaL ${isCollapsed ? "expanded" : ""}`}>
        <HeaderL toggleSidebar={toggleSidebar} />
        <div className="content-boxL">
          <Routes>
            <Route path="/" element={<h2>Welcome to Dashboard</h2>} />
            <Route path="admission" element={<AdmissionPage />} />
            <Route path="hiring" element={<HiringPage />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;
